import { FC } from "react";
import { mainTheme } from "../../theme/mainTheme";

export const PassCheckItem: FC<{
  condition: boolean | null;
  text?: string;
}> = ({ condition, text, children }) => {
  return (
    <span
      style={{
        color:
          condition !== null
            ? condition
              ? mainTheme.palette.success.main
              : mainTheme.palette.error.main
            : "initial",
      }}
    >
      {text || children}
    </span>
  );
};
